<a-header
  stream-title="{{ 'edu-admin.admin.header.title' | translate }}"
  padding="false"
>
  <a-header-item
    slot="start"
    routerLink="/user"
    routerLinkActive
    #userLink="routerLinkActive"
    [attr.active]="userLink.isActive ? '' : null"
  >
    {{ 'edu-admin.admin.header.user_page' | translate }}
  </a-header-item>
</a-header>
